export enum QUERY_KEY {
  AUTO_GROUPED_ALERTS_LIST = 'AUTO_GROUPED_ALERTS_LIST',
  AUTO_GROUPED_ALERT_DETAIL = 'AUTO_GROUPED_ALERT_DETAIL',
}
